import { render, staticRenderFns } from "./S3Image.vue?vue&type=template&id=5a5e66a8&scoped=true"
import script from "./S3Image.vue?vue&type=script&lang=ts"
export * from "./S3Image.vue?vue&type=script&lang=ts"
import style0 from "./S3Image.vue?vue&type=style&index=0&id=5a5e66a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5e66a8",
  null
  
)

export default component.exports